export const amountFormat = (amount: string, locale?: string): string => {
  const result = new Intl.NumberFormat(locale || "en", {
    minimumFractionDigits: 2,
  }).format(Number((+amount).toFixed(2)))

  return result !== "NaN" ? result : "-"
}
